<template>
  <div class="compatible-warning">
    <div class="compatible-warning-top">
      <img src="@/assets/compatibleWarning_image/logo.png" />
    </div>
    <div class="compatible-warning-center">
      <div class="compatible-warning-center-text">
        很抱歉！您正在使用的浏览器版本过低，无法正常使用我们的网站，请升级后再试
      </div>
      <div class="compatible-warning-center-tip">
        为获得最佳的浏览体验，建议您升级或选用其他浏览器，我们列出了一些最受欢迎的浏览器供您升级，点击图标将转到相应下载页
      </div>
      <ul class="compatible-warning-center-list clearfix">
        <li>
          <img src="@/assets/compatibleWarning_image/chrome.png" />
          <div>
            <a
              target="_blank"
              href="http://oss.iccec.cn/static/download_exe/GoogleChromeEnterpriseBundle64.zip"
              >本地下载</a
            >
            <span class="compatible-warning-center-list-divider">|</span>
            <a target="_blank" href="https://www.google.cn/intl/zh-CN/chrome/"
              >去官网下载</a
            >
          </div>
          <div>谷歌浏览器</div>
          <div class="compatible-warning-center-list-suffix">（强烈推荐）</div>
        </li>
        <li>
          <img src="@/assets/compatibleWarning_image/firefox.png" />
          <div>
            <a target="_blank" href="https://www.firefox.com.cn/">去官网下载</a>
          </div>
          <div>火狐浏览器</div>
        </li>
        <li>
          <img src="@/assets/compatibleWarning_image/360.png" />
          <div>
            <a target="_blank" href="https://browser.360.cn/ee/">去官网下载</a>
          </div>
          <div>360极速浏览器</div>
        </li>
        <li>
          <img src="@/assets/compatibleWarning_image/IE.png" />
          <div>
            <a
              target="_blank"
              href="https://support.microsoft.com/zh-cn/help/17621/internet-explorer-downloads"
              >去官网下载</a
            >
          </div>
          <div>IE11浏览器</div>
        </li>
      </ul>
    </div>
    <div class="compatible-warning-footer">
      <span>Copyright © 2018 中国交建 All rights reserved.</span
      ><span class="compatible-warning-footer-divider">|</span
      ><span>最终解释权：闽ICP备2022005227号-2 中交电商</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompatibleWarning"
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.compatible-warning {
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  .compatible-warning-top {
    height: 17%;
    text-align: center;
    position: relative;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      height: 9vh;
    }
  }
  .compatible-warning-center {
    height: 73%;
    background-color: #ebf4f9;
    overflow: hidden;
    color: #4a4a4a;
    .compatible-warning-center-text {
      font-size: 28px;
      margin-top: 10vh;
      text-align: center;
    }
    .compatible-warning-center-tip {
      font-size: 18px;
      margin-top: 30px;
      text-align: center;
    }
    .compatible-warning-center-list {
      margin: 15vh auto;
      width: 70%;
      li {
        float: left;
        list-style: none;
        width: 25%;
        text-align: center;
        font-size: 2vh;
        .compatible-warning-center-list-divider {
          margin: 0 5px 0;
        }
        .compatible-warning-center-list-suffix {
          color: #f7697c;
        }
        a {
          color: #7cb1fc;
        }
        img {
          height: 17vh;
        }
        div {
          text-align: center;
          margin-top: 10px;
        }
      }
    }
  }
  .compatible-warning-footer {
    height: 10%;
    text-align: center;
    font-size: 13px;
    position: relative;
    padding-top: 30px;
    .compatible-warning-footer-divider {
      margin: 0 20px 0;
    }
  }
  .clearfix:after {
    display: block;
    clear: both;
    content: "";
    visibility: hidden;
    height: 0;
  }
  .clearfix {
    zoom: 1;
  }
}
</style>
